"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _RuleGroup = _interopRequireDefault(require("./RuleGroup.style"));
var _misc = require("../misc");
var _icon = _interopRequireDefault(require("../icon"));
var _excluded = ["id", "groupOperator", "labels", "children", "isSelected", "className", "isDuplicateDisabled", "isMenuHidden", "pathKeys", "onDuplicate", "onDelete", "disabled"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var RuleGroup = function RuleGroup(_ref) {
  var id = _ref.id,
    groupOperator = _ref.groupOperator,
    labels = _ref.labels,
    children = _ref.children,
    isSelected = _ref.isSelected,
    className = _ref.className,
    isDuplicateDisabled = _ref.isDuplicateDisabled,
    isMenuHidden = _ref.isMenuHidden,
    pathKeys = _ref.pathKeys,
    onDuplicate = _ref.onDuplicate,
    onDelete = _ref.onDelete,
    disabled = _ref.disabled,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var menuItems = [];
  if (!isDuplicateDisabled) {
    menuItems.push({
      name: labels.ELIGIBILITY_DUPLICATE_GROUP,
      icon: 'ion-ios-copy',
      onClick: function onClick() {
        onDuplicate(pathKeys);
      }
    });
  }
  menuItems.push({
    name: labels.ELIGIBILITY_DELETE_GROUP,
    icon: 'ion-trash-b',
    onClick: function onClick() {
      onDelete('group', pathKeys);
    }
  });
  var operatorLabel;
  switch ((0, _utils.toUpper)(groupOperator)) {
    case 'AND':
      operatorLabel = labels.ELIGIBILITY_AND_OPERATOR;
      break;
    case 'OR':
      operatorLabel = labels.ELIGIBILITY_OR_OPERATOR;
      break;
    case 'IF':
      operatorLabel = labels.ELIGIBILITY_IF_KEYWORD;
      break;
    default:
      operatorLabel = groupOperator;
  }
  return /*#__PURE__*/_react["default"].createElement(_RuleGroup["default"], _extends({
    id: id,
    className: "".concat(className, " rule-group"),
    isSelected: isSelected,
    groupOperator: (0, _utils.toUpper)(groupOperator)
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    id: "groupOperator".concat(id),
    className: "group-operator"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "operator-label"
  }, operatorLabel), isSelected && !isMenuHidden && !disabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "edit-menu"
  }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    className: "rule-menu-list",
    menuItems: menuItems,
    position: "top-left",
    id: "".concat(id, "MenuList"),
    ignoreSingleItemLogic: true
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    icon: "ion-android-more-vertical",
    id: "".concat(id, "MenuList")
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "group-elements"
  }, children));
};
RuleGroup.propTypes = {
  /** Html id. */
  id: _propTypes["default"].string.isRequired,
  /** Html class. */
  className: _propTypes["default"].string,
  /** Elements to be displayed inside the group. (eg. Simple rules or other groups) */
  children: _propTypes["default"].node.isRequired,
  /** The logic operator that should be displayed at a block level */
  groupOperator: _propTypes["default"].oneOf(['AND', 'OR', 'IF']).isRequired,
  /** Labels that should be displayed at a block level (eg: AND, OR) */
  labels: _propTypes["default"].shape({}),
  /** Callback to perform when duplicating a rule group */
  onDuplicate: _propTypes["default"].func,
  /** Callback to perform when deleting a rule group */
  onDelete: _propTypes["default"].func,
  /** An array with the position trail of the current rule */
  pathKeys: _propTypes["default"].arrayOf(_propTypes["default"].number),
  /** Flag to indicate weather the duplicate/delete menu should be open */
  isSelected: _propTypes["default"].bool,
  /** Flag to indicate weather the current group should the duplicate group in the list menu */
  isDuplicateDisabled: _propTypes["default"].bool,
  /** Flag to indicate weather the current group should render the list menu */
  isMenuHidden: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
};
RuleGroup.defaultProps = {
  disabled: false,
  className: '',
  isSelected: false,
  labels: {},
  isDuplicateDisabled: false,
  isMenuHidden: false,
  onDuplicate: undefined,
  onDelete: undefined,
  pathKeys: []
};
var _default = exports["default"] = RuleGroup;